var _circle, _circle2, _circle3, _circle4, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "url(#paint0_linear_1995_660)",
    fillOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 105,
    fill: "url(#paint1_linear_1995_660)",
    fillOpacity: 0.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 85,
    fill: "url(#paint2_linear_1995_660)",
    fillOpacity: 0.55
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 65,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 60C89.12 60 60 89.12 60 125C60 160.88 89.12 190 125 190C160.88 190 190 160.88 190 125C190 89.12 160.88 60 125 60ZM112 157.5L79.5 125L88.665 115.835L112 139.105L161.335 89.77L170.5 99L112 157.5Z",
    fill: "url(#paint3_radial_1995_660)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1995_660",
    x1: 125,
    y1: 0,
    x2: 125,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1976D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1995_660",
    x1: 125,
    y1: 20,
    x2: 125,
    y2: 230,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#1976D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1995_660",
    x1: 125,
    y1: 40,
    x2: 125,
    y2: 210,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#1976D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1995_660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125 125) rotate(90) scale(65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1976D2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.169cbabaeec11958f7c648b40e1c1fde.svg";
export { ForwardRef as ReactComponent };